"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillsetMetadataFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SkillsetMetadataFactory = /** @class */ (function (_super) {
    __extends(SkillsetMetadataFactory, _super);
    function SkillsetMetadataFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SkillsetMetadataFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SkillsetMetadataFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SkillsetMetadataFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SkillsetMetadataFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SkillsetMetadataFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SkillsetMetadataFactory;
}(contracts_1.ContractFactory));
exports.SkillsetMetadataFactory = SkillsetMetadataFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_level",
                type: "uint256",
            },
        ],
        name: "SkillsetMaxLevelSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "SkillsetStatusUpdated",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "addSkillsetToken",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "approvedSkillsets",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getAllSkillsets",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "getSkillsetBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "isValidSkillset",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "maxLevel",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "removeSkillsetToken",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_level",
                type: "uint256",
            },
        ],
        name: "setMaxLevel",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "skillsetsArray",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=SkillsetMetadataFactory.js.map